/**
 * One-click CV request reasons for admin → applicant messaging.
 * Wording is CQC-aware: CV must align with the structured application form.
 */

export const CV_REQUEST_TEMPLATES = [
  {
    id: 'ten_year_coverage',
    label: '10-year history missing',
    modes: ['replacement'],
    reason:
      'Your CV does not appear to cover the full 10-year employment history required for safer recruitment. Please upload an updated CV listing every role, employer, and date for the last 10 years — matching the employment history on your application form.',
  },
  {
    id: 'dates_mismatch',
    label: 'Dates don\'t match application',
    modes: ['replacement'],
    reason:
      'The employment dates on your CV do not match the employment history on your application form. Please upload a corrected CV so both records align, or contact us if the application form needs updating.',
  },
  {
    id: 'roles_missing_from_cv',
    label: 'Roles missing from CV',
    modes: ['replacement'],
    reason:
      'One or more employers listed on your application form are not shown on your CV. Please upload an updated CV that includes all roles declared on your application, with start and end dates.',
  },
  {
    id: 'roles_missing_from_application',
    label: 'CV has undeclared roles',
    modes: ['replacement'],
    reason:
      'Your CV lists employment that is not declared on your application form. Please either update your application employment history to match your CV, or upload a CV that reflects only what you declared on the application.',
  },
  {
    id: 'no_extractable_history',
    label: 'CV not readable',
    modes: ['replacement'],
    reason:
      'We could not extract a clear employment history from your CV. Please upload a well-formatted PDF (or Word) with distinct roles, employers, and dates for the last 10 years.',
  },
  {
    id: 'gaps_need_clarification',
    label: 'Gaps need clarification',
    modes: ['replacement', 'upload'],
    reason:
      'Your CV leaves unexplained gaps in your employment history. Please upload an updated CV covering the full 10-year period, or explain any gaps of 30 days or more in your worker dashboard.',
  },
  {
    id: 'initial_upload',
    label: 'Request first CV',
    modes: ['upload'],
    reason:
      'Please upload your CV (PDF or Word) via your worker dashboard. It should list your employment history for the last 10 years and match the details on your application form.',
  },
  {
    id: 'professional_format',
    label: 'Professional format needed',
    modes: ['replacement'],
    reason:
      'Please upload a professionally presented CV in PDF format with clear sections for employment history (employer, job title, start and end dates) for the last 10 years, consistent with your application form.',
  },
];

export function getCvRequestTemplatesForMode(mode = 'replacement') {
  return CV_REQUEST_TEMPLATES.filter(
    (t) => !t.modes?.length || t.modes.includes(mode)
  );
}

export function getCvRequestTemplateById(id) {
  return CV_REQUEST_TEMPLATES.find((t) => t.id === id) || null;
}

export function getSuggestedTemplateId(alignment) {
  if (!alignment) return null;
  return alignment.suggested_template_id || null;
}